document.addEventListener('DOMContentLoaded', function() {
  const MOBILE_BREAKPOINT = 768;
  
  document.querySelectorAll('carousel-slider[data-autoplay-mobile="true"]').forEach(slider => {
    const interval = parseInt(slider.getAttribute('data-autoplay-interval')) || 3000;
    const nextButton = slider.querySelector('.slider-nav__btn[name="next"]');
    const slides = slider.querySelectorAll('.slider__item');
    let autoplayInterval;
    let isAnimating = false;

    // Mobile detection
    function isMobile() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    // Get current active slide index
    function getCurrentSlideIndex() {
      // Find the active slide using various methods
      for (let i = 0; i < slides.length; i++) {
        const slide = slides[i];
        const rect = slide.getBoundingClientRect();
        const sliderRect = slider.getBoundingClientRect();
        
        // Check if slide is visible in the slider viewport
        if (rect.left >= sliderRect.left - 10 && rect.left <= sliderRect.left + 10) {
          return i;
        }
      }
      
      // Fallback: look for active class or aria attributes
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('active') || 
            slides[i].getAttribute('aria-hidden') === 'false') {
          return i;
        }
      }
      
      return 0; // Default to first slide
    }

    // Infinite loop function
    function advanceSlide() {
      if (!isMobile() || isAnimating) return;
      
      isAnimating = true;
      
      const currentIndex = getCurrentSlideIndex();
      
      if (currentIndex >= slides.length - 1) {
        // At last slide, go to first slide
        
        // Scroll to the beginning instantly
        const sliderContainer = slider.querySelector('.slider');
        if (sliderContainer) {
          sliderContainer.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        }
      } else {
        // Go to next slide normally
        if (nextButton) {
          nextButton.click();
        }
      }
      
      // Reset animation lock
      setTimeout(() => {
        isAnimating = false;
      }, 600);
    }

    // Start autoplay
    function startAutoplay() {
      if (!isMobile()) return;
      stopAutoplay();
      autoplayInterval = setInterval(advanceSlide, interval);
    }

    // Stop autoplay
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    // Add centering styles for mobile
    function applyCenteringStyles() {
      if (!isMobile()) return;
      
      // Add centering to each slide
      slides.forEach(slide => {
        slide.style.display = 'flex';
        slide.style.flexDirection = 'column';
        slide.style.justifyContent = 'center';
        slide.style.alignItems = 'center';
        slide.style.textAlign = 'center';
        // slide.style.minHeight = '200px'; // Ensure minimum height
        
        // Center any content inside
        const textContent = slide.querySelector('.icons-with-text__text');
        if (textContent) {
          textContent.style.textAlign = 'center';
          textContent.style.width = '100%';
        }
        
        // Center icons
        const icon = slide.querySelector('.custom-icon, svg');
        if (icon) {
          icon.style.margin = '0 auto';
          icon.style.display = 'block';
        }
      });
    }

    // Remove centering styles for desktop
    function removeCenteringStyles() {
      slides.forEach(slide => {
        slide.style.display = '';
        slide.style.flexDirection = '';
        slide.style.justifyContent = '';
        slide.style.alignItems = '';
        slide.style.textAlign = '';
        // slide.style.minHeight = '';
        
        const textContent = slide.querySelector('.icons-with-text__text');
        if (textContent) {
          textContent.style.textAlign = '';
          textContent.style.width = '';
        }
        
        const icon = slide.querySelector('.custom-icon, svg');
        if (icon) {
          icon.style.margin = '';
          icon.style.display = '';
        }
      });
    }

    // Initialize
    if (isMobile()) {
      applyCenteringStyles();
      startAutoplay();
    }

    // Pause on interaction
    slider.addEventListener('mouseenter', () => {
      if (isMobile()) stopAutoplay();
    });
    
    slider.addEventListener('mouseleave', () => {
      if (isMobile()) startAutoplay();
    });
    
    slider.addEventListener('touchstart', () => {
      if (isMobile()) stopAutoplay();
    });
    
    slider.addEventListener('touchend', () => {
      if (isMobile()) {
        setTimeout(startAutoplay, 1000);
      }
    });

    // Handle window resize
    window.addEventListener('resize', function() {
      const mobile = isMobile();
      
      if (mobile) {
        applyCenteringStyles();
        startAutoplay();
      } else {
        removeCenteringStyles();
        stopAutoplay();
      }
    });

    // Clean up
    window.addEventListener('beforeunload', stopAutoplay);
  });
});